import * as React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { FormFieldComponentProps } from '@sheerid/jslib';
import { PostalCodeInputComponent } from './PostalCodeInputComponent';

const PostalCodeComponent = ({ value, isErrored, onChange, placeholder }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-postal-code__label">
            <div className="sid-l-space-top-md" />
            <label className="sid-postal-code__label">
                <div className="sid-field__label-with-explanation sid-l-space-btm-sm">
                    <div className="sid-field__label sid-field__label--required"></div>
                </div>
            </label>
            <PostalCodeInputComponent
                value={value}
                isValid={!isErrored}
                onChange={onChange}
                placeholoder={placeholder}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidPostalCode"
                            defaultMessage="Invalid postal code" />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  PostalCodeComponent };
